export const styles = {
  count: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: 1,
    top: '5px',
    right: '5px',
    width: '16px',
    height: '16px',
    background: '#00000040',
    color: '#FFF',
    backdropFilter: 'blur(34px)',
    fontFamily: 'Inter',
    fontSize: '8px',
    fontWeight: 500,
    lineHeight: '150%',
    borderRadius: '50%',
  },
};
